import { useEffect, useState } from "react";
import { validateVariant } from "./variantValidation";
import { branchExtraCommission, withNumericCommission } from "./branchCommission";
import { useLocation } from "react-router-dom";
import SaleFields from "./Components/SaleFields";
import { saleDiscountError } from "./sale";

import Footer from "../../CoreComponents/Footer";
import Header from "../../CoreComponents/Header";
import MainHeader from "../../CoreComponents/MainHeader";
import NavBar from "../../CoreComponents/NavBar";
import axios from "axios";
import {
  is_shop_admin,
  is_shop_manager,
  franchise,
  branch,
  url,
  works_in_franchise,
  is_back_office,
} from "../../Functionalities/Config";
import InnerCategory from "./InnerCategory";
import ToggleButton from "../../CoreComponents/ToggleButton";

import {
  getAllBranches,
  ManageCategory,
  ManageProducts,
  ManageRestaurant,
  ManageVariants,
  showMessage,
  formatTime,
  getToken,
} from "../../Functionalities/Functions";
import { ManageSloats } from "../Sloats/Functions";
import AddTopComponent from "../../CoreComponents/AddTopComponent";
import AddBottomComponent from "../../CoreComponents/AddBottomComponent";
import { ManageInnerCategory } from "../Menu/Logic";
import ImageUploadWithCrop from "../../CoreComponents/ImageUploadWithCrop";
import { PICTURE_SHAPES } from "../../Functionalities/pictureShapes";

const newVariantDefaults = {
  id: "",
  varient_id: "",
  varient_name: "",
  magnitude: "",
  rate: "",
  mrp: 0,
  offer_rate: "",
  name: "",
  dual_name: "",
  description: "",
  offer_enabled: false,
  dual_description: "",
  food_type: "",
  order_limit: "",
  commission_rate: 0,
};

const emptyProduct = (branchId) => ({
  name: "",
  category: "",
  category_tag: [],
  price: "",
  description: "",
  images: [],
  checkbox: "true",
  variants: [],
  type: "",
  branch: branchId,
  product_commission: "",
  on_sale: false,
  sale_discount: "",
  sloats: [],
  // inner_category: ""
  inner_category: [],

  is_new: false,
  is_popular: false,
  is_recommended: false,
  is_bundle: false,
  is_trending: false,
  occasion_tag: "",
});

function Body({ categorys, varients }) {
  const location = useLocation();
  const [disable, setdisable] = useState(false);
  const [categoriesList, setCategoriesList] = useState([]);
  const [data, setData] = useState(() =>
    emptyProduct(
      (is_shop_admin || is_shop_manager) && branch && branch.length > 0
        ? branch[0].id || branch[0]
        : ""
    )
  );
  const [catName, setcatName] = useState([]);
  const [compression, setCompression] = useState(true);

  const availableCategories =
    Array.isArray(categorys) && categorys.length > 0
      ? categorys
      : categoriesList;

  const [variantsData, setVariantsData] = useState(newVariantDefaults);
  const [extraCommission, setExtraCommission] = useState(0);

  const [sloats, setSloats] = useState([]);
  const [errors, setErrors] = useState([]);
  const [branches, setBranches] = useState([]);
  const [reload, setReload] = useState(false);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const branchFromQuery =
      searchParams.get("branch") ||
      searchParams.get("branch_id") ||
      searchParams.get("restaurant") ||
      searchParams.get("restaurant_id");
    const initialBranch = branchFromQuery || location.state?.branch || "";
    if (initialBranch) {
      setData((prev) => ({ ...prev, branch: initialBranch }));
      getBranchFranchiseAndSlots(initialBranch);
    }
  }, [location]);

  useEffect(() => {
    getBranches();
    getSloats();
    getCategories();
  }, [reload]);

  const getCategories = async () => {
    let params = "for_dropdown=true&is_dropdown=true&page_wise=false&order_by_name=true";
    let result = await ManageCategory("", "", "get", params);
    const list = Array.isArray(result?.data)
      ? result.data
      : (Array.isArray(result?.data?.results)
          ? result.data.results
          : (Array.isArray(result?.data?.data) ? result.data.data : []));
    setCategoriesList(list);
  };

  const getBranches = async () => {
    let params = "for_dropdown=true&is_dropdown=true&page_wise=false&order_by_name=true";
    let res = await getAllBranches(params);
    let list = Array.isArray(res?.data)
      ? res.data
      : (Array.isArray(res?.data?.results)
          ? res.data.results
          : (Array.isArray(res?.data?.data) ? res.data.data : []));

    if (list.length === 0) {
      let restRes = await ManageRestaurant("", "", "get", params);
      list = Array.isArray(restRes?.data)
        ? restRes.data
        : (Array.isArray(restRes?.data?.results)
            ? restRes.data.results
            : (Array.isArray(restRes?.data?.data) ? restRes.data.data : []));
    }
    setBranches(list);
  };

  const getSloats = (fId) => {
    let params = "page_wise=0";
    let targetFranchise = fId;

    if (!targetFranchise) {
      if (works_in_franchise) {
        targetFranchise = franchise?.id;
      } else if (is_shop_admin || is_shop_manager) {
        targetFranchise = branch && branch.length > 0 ? (branch[0].franchise?.id || branch[0].franchise) : "";
      }
    }

    if (targetFranchise) {
      params += `&franchise=${targetFranchise}`;
    }

    let result = ManageSloats("", "get", "", params);
    result
      .then((result) => {
        const slotsArray = result && result.data && Array.isArray(result.data.data)
          ? result.data.data
          : (result && result.data && Array.isArray(result.data) ? result.data : []);
        setSloats(slotsArray);
      })
      .catch((err) => {
        showMessage(
          "Loading failed",
          "danger",
          "Loading error",
          "top",
          "top-right",
          0,
        );
      });
  };

  useEffect(() => {
    setVariantsData((prev) => ({ ...prev, commission_rate: extraCommission }));
  }, [extraCommission]);

  const getBranchFranchiseAndSlots = async (bId) => {
    if (!bId) {
      setExtraCommission(0);
      return;
    }
    try {
      const response = await axios.get(
        `${url}/branch/details/?id=${bId}`,
        { headers: { Authorization: getToken() } }
      );
      if (response.data && response.data.results && response.data.results.length > 0) {
        const branchObj = response.data.results[0];
        setExtraCommission(branchExtraCommission(branchObj));
        const fId = branchObj.franchise && typeof branchObj.franchise === 'object'
          ? branchObj.franchise.id
          : branchObj.franchise;
        getSloats(fId);
      }
    } catch (error) {
      console.error("Failed to get selected branch franchise:", error);
    }
  };

  useEffect(() => {
    if (errors.length > 0) {
      showMessage(
        errors[0],
        "danger",
        "This field cannot be empty",
        "top",
        "top-right",
        0,
      );
    }
  }, [errors]);

  function Pop(index) {
    var array = catName;
    array.splice(index, 1);
    var x = [];
    x = array;
    setcatName([]);
    setData({ ...data, inner_category: [] });
    array.map((arr) => {
      setcatName((prev) => [...prev, { id: arr.id, name: arr.name }]);
      // setData({ ...data, inner_category: [...data.inner_category, arr.id] })
    });

    console.warn("pop");

  }

  const onChange = (e) => {
    if (e.target.value !== "") {
      var selectedSloat = sloats.find((item) => item.id == e.target.value);
      setData({
        ...data,
        sloats: [...data.sloats, selectedSloat],
        sloatId: "",
      });
      setSloats(sloats.filter((item) => item.id !== selectedSloat.id));
    }
  };

  const handleSloatRemove = (item) => {
    var newSloats = data.sloats;
    newSloats = newSloats.filter((nslt) => nslt.id != item.id);
    setData({ ...data, sloats: newSloats });
    setSloats((prev) => [...prev, item]);
  };

  const clearVariantData = () => {
    setVariantsData({ ...newVariantDefaults, commission_rate: extraCommission });
  };
  const variantValidation = () => {
    const error = validateVariant(variantsData);
    if (error) {
      showMessage(error, "danger", "Validation failed", "top", "top-right", 0);
      return;
    }
    setData({
      ...data,
      variants: [...data.variants, { ...withNumericCommission(variantsData), id: Date.now() }],
    });

    return 1;
  };
  // void 0

  return (
    <div>
      <div class="content-body">
        <div class="container-fluid">
          <AddTopComponent />
          <div className="col-xl-12 col-lg-12">
            <div className="card">
              <div className="card-body">
                <div className="basic-form">
                  <form>
                    {is_back_office && (
                      <div className="form-group row">
                        <label className="col-sm-3 col-form-label">
                          Restaurant<span className="required"> * </span> :{" "}
                        </label>
                        <div className="col-sm-9">
                          <select
                            value={data.branch}
                            className="form-control form-control-lg"
                            onChange={(e) => {
                              setData({ ...data, branch: e.target.value });
                              getBranchFranchiseAndSlots(e.target.value);
                            }}
                          >
                            <option value={""}>---Select Restaurant---</option>
                            {(Array.isArray(branches) ? branches : []).map((item) => (
                              <option key={item.id} value={item.id}>
                                {item.name}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    )}
                    <div className="form-group row">
                      <label className="col-sm-3 col-form-label">
                        Product name <span class="required">*</span> :{" "}
                      </label>
                      <div className="col-sm-9">
                        <input
                          type="text"
                          className="form-control"
                          value={data.name}
                          onChange={(e) =>
                            setData({ ...data, name: e.target.value })
                          }
                        />
                      </div>
                    </div>
                    {!is_shop_admin && !is_shop_manager && (
                      <div className="form-group row">
                        <label className="col-sm-3 col-form-label">
                          Product Commission
                          <i
                            style={{ cursor: "pointer" }}
                            class="ml-1 fs-20 fa fa-info-circle"
                            title="set blank to disable product commission, set 0 to do not take commisson for the product, set other number to take specified commission for that product"
                          ></i>
                        </label>
                        <div className="col-sm-9">
                          <input
                            className="form-control"
                            value={data.product_commission}
                            type="number"
                            onKeyDown={(evt) =>
                              ((evt.key === "e" || evt.key === "-") &&
                                evt.preventDefault()) ||
                              (evt.key === "E" && evt.preventDefault())
                            }
                            onWheelCapture={(e) => {
                              e.target.blur();
                            }}
                            onChange={(e) =>
                              setData({
                                ...data,
                                product_commission: e.target.value,
                              })
                            }
                          />
                        </div>
                      </div>
                    )}

                    <SaleFields
                      data={data}
                      setData={setData}
                      rate={data.variants[0]?.rate ?? variantsData.rate}
                    />

                    {/* inner category            */}
                    <div class="form-group row">
                      <label className="col-sm-3 col-form-label">
                        Menu <span class="required"> * </span>:{" "}
                      </label>
                      <div class="col-sm-9">
                        <button
                          type="button"
                          class="btn btn-primary light form-control mb-2 mb-2"
                          data-toggle="modal"
                          data-target="#userSelectModal"
                        >
                          Select Menu
                        </button>
                        <InnerCategory
                          existingTag={catName}
                          customerFunction={(tagList) => {
                            setData({ ...data, inner_category: tagList });
                          }}
                          nameFunction={(catNames) => {
                            setcatName(catNames);
                          }}
                        />
                      </div>
                    </div>

                    {catName.length != 0 && (
                      <div class="form-group row">
                        <label className="col-sm-3 col-form-label">
                          Selected Menus{" "}
                          {/* <span class="required"> * </span>  */}:{" "}
                        </label>
                        <div className="col-sm-9">
                          <div class="row">
                            {catName &&
                              catName.map((cat, index) => {
                                return (
                                  <div
                                    className="col-3"
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "space-around",
                                      borderRadius: "20px",
                                      backgroundColor: "#46B23C",
                                      margin: "8px",
                                      color: "white",
                                    }}
                                  >
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                      }}
                                    >
                                      <h6
                                        style={{
                                          margin: "6px",
                                          color: "white",
                                        }}
                                      >
                                        {cat.name}
                                      </h6>
                                      <span
                                        style={{
                                          fontSize: 16,
                                          height: "20px",
                                          width: "20px",
                                          cursor: "pointer",
                                          marginTop: 5,
                                          marginLeft: 10,
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          textAlign: "center",
                                          color: "red",
                                          borderRadius: "5px",
                                          backgroundColor: "white",
                                          float: "right",
                                        }}
                                        onClick={(e) => {
                                          Pop(index);
                                        }}
                                      >
                                        {" "}
                                        <i
                                          className="fa fa-trash-o text-danger"
                                          style={{ cursor: "pointer" }}
                                        ></i>
                                      </span>
                                    </div>
                                  </div>
                                );
                              })}
                          </div>
                        </div>
                      </div>
                    )}

                    <div class="form-group row">
                      <label className="col-sm-3 col-form-label">
                        Description :{" "}
                      </label>
                      <div class="col-sm-9">
                        <textarea
                          class="form-control"
                          rows="4"
                          id="comment"
                          value={data.description}
                          onChange={(e) =>
                            setData({ ...data, description: e.target.value })
                          }
                        ></textarea>
                      </div>
                    </div>
                    <br />
                    {/* add variant modal2  start*/}
                    {/* <AddVariant2 /> */}
                    <div className="form-group row">
                      <label className="col-sm-3 col-form-label">
                        Variant <span class="required">*</span> :{" "}
                      </label>
                      <div className="col-sm-9">
                        <p>
                          <a
                            data-toggle="modal"
                            onClick={() => setErrors([])}
                            data-target="#sendMessageModal"
                            href=""
                          >
                            <span
                              className="item"
                              className="badge badge-circle badge-success "
                            >
                              <i class="ti-plus"></i>
                            </span>
                          </a>{" "}
                          Add Variant/Portion
                        </p>
                        <div className="modal fade" id="sendMessageModal">
                          <div
                            className="modal-dialog modal-dialog-centered"
                            role="document"
                          >
                            <div className="modal-content">
                              <div className="modal-header">
                                <h5 className="modal-title">
                                  Add Variant/Portion
                                </h5>
                                <button
                                  type="button"
                                  className="close"
                                  data-dismiss="modal"
                                >
                                  <span>×</span>
                                </button>
                              </div>
                              <div className="modal-body">
                                {/* <h6>
                                  Example : Half chiken biriyani
                                  Rs.80
                                </h6> */}

                                <form className="comment-form">
                                  <div className="row">
                                    <div className="col-lg-6">
                                      <div className="form-group">
                                        <label className="text-black font-w600">
                                          Variant/Portion{" "}
                                          <span className="required">*</span>
                                        </label>
                                        <input
                                          type="text"
                                          className="form-control"
                                          name="name"
                                          placeholder="Name"
                                          value={variantsData.name}
                                          onChange={(e) =>
                                            setVariantsData({
                                              ...variantsData,
                                              name: e.target.value,
                                            })
                                          }
                                        />
                                      </div>
                                    </div>

                                    <div className="col-lg-6">
                                      <div className="form-group">
                                        <label className="text-black font-w600">
                                          Food Type{" "}
                                          <span className="required">*</span>
                                        </label>
                                        <select
                                          value={variantsData.food_type}
                                          id={variantsData.food_type}
                                          class="form-control form-control-lg  "
                                          onChange={(e) =>
                                            setVariantsData({
                                              ...variantsData,
                                              food_type: e.target.value,
                                            })
                                          }
                                        >
                                          <option value={""}>
                                            Select type
                                          </option>
                                          <option
                                            value={"vegetarian"}
                                            id={"vegetarian"}
                                          >
                                            {" "}
                                            Vegetarian
                                          </option>
                                          <option
                                            value={"non-vegetarian"}
                                            id={"non-vegetarian"}
                                          >
                                            Non-vegetarian
                                          </option>
                                          <option
                                            value={"eggetarian"}
                                            id={"eggetarian"}
                                          >
                                            {" "}
                                            Eggetarian
                                          </option>
                                        </select>
                                      </div>
                                    </div>

                                    <div className="col-lg-6">
                                      <div className="form-group">
                                        <label className="text-black font-w600">
                                          Retail Price
                                          <span className="required">*</span>
                                        </label>
                                        <input
                                          type="number"
                                          className="form-control"
                                          placeholder="Rate"
                                          name="rate"
                                          onKeyDown={(evt) =>
                                            ((evt.key === "e" ||
                                              evt.key === "-") &&
                                              evt.preventDefault()) ||
                                            (evt.key === "E" &&
                                              evt.preventDefault())
                                          }
                                          onWheelCapture={(e) => {
                                            e.target.blur();
                                          }}
                                          value={variantsData.rate}
                                          onChange={(e) =>
                                            setVariantsData({
                                              ...variantsData,
                                              rate: e.target.value,
                                            })
                                          }
                                        />
                                      </div>
                                    </div>

                                    <div className="col-lg-6">
                                      <div className="form-group">
                                        <label className="text-black font-w600">
                                          Offer Price
                                          {variantsData.offer_enabled && <span className="required">*</span>}
                                        </label>
                                        <input
                                          type="number"
                                          className="form-control"
                                          placeholder="Rate"
                                          name="rate"
                                          onKeyDown={(evt) =>
                                            ((evt.key === "e" ||
                                              evt.key === "-") &&
                                              evt.preventDefault()) ||
                                            (evt.key === "E" &&
                                              evt.preventDefault())
                                          }
                                          onWheelCapture={(e) => {
                                            e.target.blur();
                                          }}
                                          value={variantsData.offer_rate}
                                          onChange={(e) =>
                                            setVariantsData({
                                              ...variantsData,
                                              offer_rate: e.target.value,
                                            })
                                          }
                                        />
                                      </div>
                                    </div>

                                    <div className="col-lg-6">
                                      <div className="form-group">
                                        <label className="text-black font-w600">
                                          {" "}
                                          Offer Enabled ?
                                        </label>
                                        <ToggleButton
                                          inactiveLabel={""}
                                          activeLabel={""}
                                          colors={{
                                            activeThumb: {
                                              base: "rgb(27 255 10)",
                                            },
                                            inactiveThumb: {
                                              base: "#ED3833",
                                            },
                                          }}
                                          value={variantsData.offer_enabled}
                                          checked={variantsData.offer_enabled}
                                          thumbStyle={{ borderradius: 5 }}
                                          trackStyle={{ borderradius: 5 }}
                                          onToggle={(e) => {
                                            setVariantsData({
                                              ...variantsData,
                                              offer_enabled: !e,
                                            });
                                          }}
                                        />
                                      </div>
                                    </div>

                                    <div className="col-lg-6">
                                      <div className="form-group">
                                        <label className="text-black font-w600">
                                          Order limit{" "}
                                        </label>
                                        <input
                                          type="number"
                                          className="form-control"
                                          name="order_limit"
                                          placeholder="order limit"
                                          value={variantsData.order_limit}
                                          onChange={(e) =>
                                            setVariantsData({
                                              ...variantsData,
                                              order_limit: e.target.value,
                                            })
                                          }
                                        />
                                      </div>
                                    </div>

                                    <div className="col-lg-6">
                                      <div className="form-group">
                                        <label className="text-black font-w600">
                                          Extra Commission
                                        </label>
                                        <input
                                          type="number"
                                          className="form-control"
                                          name="commission_rate"
                                          placeholder="extra commission"
                                          value={variantsData.commission_rate}
                                          onChange={(e) =>
                                            setVariantsData({
                                              ...variantsData,
                                              commission_rate: e.target.value,
                                            })
                                          }
                                        />
                                      </div>
                                    </div>

                                    <div className="col-lg-12">
                                      <div className="form-group mb-0 text-center">
                                        <button
                                          style={{ marginRight: 10 }}
                                          data-dismiss="modal"
                                          type="submit"
                                          id="tests"
                                          className="submit btn btn-danger"
                                          name="cancell"
                                          onClick={(e) => {
                                            e.preventDefault();
                                            // void 0
                                            // void 0
                                            // void 0
                                            clearVariantData();
                                          }}
                                        >
                                          cancel
                                        </button>

                                        <button
                                          style={{ marginRight: 10 }}
                                          data-dismiss={
                                            errors === [] ? "modal" : ""
                                          }
                                          className="submit btn btn-primary"
                                          onClick={(e) => {
                                            e.preventDefault();
                                            let res = variantValidation();
                                            if (!res) {
                                              return 0;
                                            }
                                            clearVariantData();

                                            setData({
                                              ...data,
                                              variants: [
                                                ...data.variants,
                                                {
                                                  ...withNumericCommission(variantsData),
                                                  id: Date.now(),
                                                },
                                              ],
                                            });

                                            // window.location.reload();
                                          }}
                                          name="add"
                                        >
                                          Add new
                                        </button>
                                        <button
                                          data-dismiss="modal"
                                          type="submit"
                                          id="tests"
                                          defaultValue="Post Comment"
                                          className="submit btn btn-primary"
                                          name="add new"
                                          onClick={(e) => {
                                            e.preventDefault();

                                            let res = variantValidation();
                                            if (!res) {
                                              return 0;
                                            }

                                            setData({
                                              ...data,
                                              variants: [
                                                ...data.variants,
                                                {
                                                  ...withNumericCommission(variantsData),
                                                  id: Date.now(),
                                                },
                                              ],
                                            });
                                            clearVariantData();
                                          }}
                                        >
                                          Submit
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </form>
                              </div>
                            </div>
                          </div>
                        </div>
                        {data.variants.length > 0 &&
                          data.variants.map((item, index) => {
                            return (
                              <p>
                                {" "}
                                <a href="">
                                  <span
                                    className="item"
                                    className="badge badge-circle badge-danger "
                                    onClick={(e) => {
                                      e.preventDefault();
                                      setData({
                                        ...data,
                                        variants: data.variants.filter(
                                          (var_item) => var_item.id !== item.id,
                                        ),
                                      });
                                    }}
                                  >
                                    <i class="fa fa-trash"></i>
                                  </span>
                                </a>{" "}
                                {item.name}
                                <b style={{ color: "black", fontSize: "16px" }}>
                                  {" | "}
                                </b>
                                Rs :{" "}
                                {item.offer_enabled ? (
                                  <b>Offer Price {item.offer_rate}</b>
                                ) : (
                                  item.rate
                                )}{" "}
                                {` (rate : ${item.rate}, offer rate : ${item.offer_rate})`}
                                <b style={{ color: "black", fontSize: "16px" }}>
                                  {" | "}
                                </b>
                                Max order limit : {item.order_limit}
                              </p>
                            );
                          })}
                      </div>
                    </div>
                    {/* add variant modal2 end */}
                    <div className="form-group row">
                      <label className="col-sm-3 col-form-label">
                        Product Images{"(182x182)"}
                        <span class="required">*</span> : <br />
                        <b>Compress image </b>
                        <input
                          type="checkbox"
                          checked={compression}
                          onChange={(e) => {
                            setCompression(e.target.checked);
                            setData({ ...data, images: "" });
                          }}
                        />
                      </label>
                      <div className="col-sm-9">
                        <ImageUploadWithCrop
                          value={data.images}
                          onChange={(file) =>
                            setData({
                              ...data,
                              images: file,
                            })
                          }
                          {...PICTURE_SHAPES.product}
                          compress={compression}
                        />
                      </div>
                    </div>
                    <div class="form-group row">
                      <label className="col-sm-3 col-form-label">
                        Slots :{" "}
                      </label>
                      <div class="col-sm-9">
                        <select
                          name="categoryid"
                          value={data.sloatId}
                          onChange={(e) => onChange(e)}
                          className="form-control "
                          data-placeholder="Choose Slots"
                          tabIndex={-1}
                          aria-hidden="true"
                        >
                          <option value={""}>
                            {"------Select slots------"}
                          </option>
                          {sloats.map((item, index) => (
                            <option key={index} value={item.id}>
                              {item.name} - {item.from_time} to {item.to_time}
                            </option>
                          ))}
                        </select>
                        <div
                          style={{
                            marginTop: 5,
                            color: "white",
                            display: "flex",
                            flexWrap: "wrap",
                          }}
                        >
                          {data.sloats.map((item) => (
                            <div
                              style={{
                                marginBottom: 5,
                                paddingLeft: 3,
                                paddingRight: 10,
                                width: 280,
                                height: 30,
                                backgroundColor: "#3fb049",
                                marginRight: 5,
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                            >
                              <p>
                                {item.name} - {formatTime(item.from_time)} to{" "}
                                {formatTime(item.to_time)}
                              </p>
                              <span
                                style={{ fontSize: 16, cursor: "pointer" }}
                                onClick={() => handleSloatRemove(item)}
                              >
                                x
                              </span>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>

                    <div class="form-group row">
                      <label className="col-sm-3 col-form-label">
                        is new :{" "}
                      </label>
                      <div class="col-sm-9" style={{ marginTop: -15 }}>
                        <div className="col-sm-6" style={{}}>
                          <div>
                            <input
                              className="form-check-input"
                              type="checkbox"
                              checked={data.is_new}
                              onChange={(e) => {
                                setData({
                                  ...data,
                                  is_new: e.target.checked,
                                });
                              }}
                            />
                          </div>

                          <div
                            style={{
                              marginTop: 20,
                              display: "flex",
                              textAlign: "center",
                            }}
                          >
                            <label className="form-check-label">{""}</label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="form-group row">
                      <label className="col-sm-3 col-form-label">
                        is popular :{" "}
                      </label>
                      <div class="col-sm-9" style={{ marginTop: -15 }}>
                        <div className="col-sm-6" style={{}}>
                          <div>
                            <input
                              className="form-check-input"
                              type="checkbox"
                              checked={data.is_popular}
                              onChange={(e) => {
                                setData({
                                  ...data,
                                  is_popular: e.target.checked,
                                });
                              }}
                            />
                          </div>

                          <div
                            style={{
                              marginTop: 20,
                              display: "flex",
                              textAlign: "center",
                            }}
                          >
                            <label className="form-check-label">{""}</label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="form-group row">
                      <label className="col-sm-3 col-form-label">
                        is recommended :{" "}
                      </label>
                      <div class="col-sm-9" style={{ marginTop: -15 }}>
                        <div className="col-sm-6" style={{}}>
                          <div>
                            <input
                              className="form-check-input"
                              type="checkbox"
                              checked={data.is_recommended}
                              onChange={(e) => {
                                setData({
                                  ...data,
                                  is_recommended: e.target.checked,
                                });
                              }}
                            />
                          </div>

                          <div
                            style={{
                              marginTop: 20,
                              display: "flex",
                              textAlign: "center",
                            }}
                          >
                            <label className="form-check-label">{""}</label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="form-group row">
                      <label className="col-sm-3 col-form-label">
                        is bundle :{" "}
                      </label>
                      <div class="col-sm-9" style={{ marginTop: -15 }}>
                        <div className="col-sm-6" style={{}}>
                          <div>
                            <input
                              className="form-check-input"
                              type="checkbox"
                              checked={data.is_bundle}
                              onChange={(e) => {
                                setData({
                                  ...data,
                                  is_bundle: e.target.checked,
                                });
                              }}
                            />
                          </div>

                          <div
                            style={{
                              marginTop: 20,
                              display: "flex",
                              textAlign: "center",
                            }}
                          >
                            <label className="form-check-label">{""}</label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="form-group row">
                      <label className="col-sm-3 col-form-label">
                        is trending :{" "}
                      </label>
                      <div class="col-sm-9" style={{ marginTop: -15 }}>
                        <div className="col-sm-6" style={{}}>
                          <div>
                            <input
                              className="form-check-input"
                              type="checkbox"
                              checked={data.is_trending}
                              onChange={(e) => {
                                setData({
                                  ...data,
                                  is_trending: e.target.checked,
                                });
                              }}
                            />
                          </div>

                          <div
                            style={{
                              marginTop: 20,
                              display: "flex",
                              textAlign: "center",
                            }}
                          >
                            <label className="form-check-label">{""}</label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="form-group row">
                      <label className="col-sm-3 col-form-label">
                        occasion tag :{" "}
                      </label>
                      <div class="col-sm-9">
                        <input
                          className="form-control"
                          type="text"
                          value={data.occasion_tag}
                          onChange={(e) => {
                            setData({
                              ...data,
                              occasion_tag: e.target.value,
                            });
                          }}
                        />
                      </div>
                    </div>

                    {
                      <AddBottomComponent
                        disable={disable}
                        saveButton={(e) => {
                          e.preventDefault();
                          setdisable(true);

                          setErrors([]);
                          // void 0
                          if (
                            works_in_franchise
                          ) {
                            if (data.branch === "") {
                              setdisable(false);

                              setErrors((prev) => [...prev, "Restaurant"]);
                              return;
                            }
                          }
                          // void 0
                          // void 0

                          if (data.name === "") {
                            setdisable(false);
                            setErrors((prev) => [...prev, "name"]);
                            return;
                          }

                          if (data.images.length === 0) {
                            setdisable(false);
                            setErrors((prev) => [...prev, "images"]);
                            return;
                          }

                          if (catName.length < 1) {
                            setdisable(false);
                            setErrors((prev) => [...prev, "Menu"]);
                            return;
                          }

                          const saleError = saleDiscountError(data);
                          if (saleError) {
                            setdisable(false);
                            showMessage(saleError, "danger", "Error!", "top", "top-right", 0);
                            return;
                          }

                          var response = ManageProducts(e, data, "add", "");
                          response
                            .then((res) => {

                              setdisable(false);
                              // void 0
                              if (res.data.Status) {
                                showMessage(
                                  "Product successfully added",
                                  "success",
                                  "Success!",
                                  "top",
                                  "top-right",
                                  0,
                                );

                                const keptBranch = data.branch;
                                setData(emptyProduct(keptBranch));
                                setcatName([]);
                                clearVariantData();
                                if (keptBranch) {
                                  getBranchFranchiseAndSlots(keptBranch);
                                } else {
                                  getSloats();
                                }
                              } else {
                                showMessage(
                                  res.data.Error,
                                  "danger",
                                  "Failed!",
                                  "top",
                                  "top-right",
                                  0,
                                );
                              }
                            })
                            .catch((err) => {
                            });
                        }}
                      />
                    }
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function AddProduct() {
  const headers = "Add Products";

  const [variantData, setVariantData] = useState([]);

  useEffect(() => {
    getCategoryData();
  }, []);

  const [catData, setCatData] = useState([]);

  const getCategoryData = async () => {
    let params = "for_dropdown=true&is_dropdown=true&page_wise=false&order_by_name=true";
    let result = await ManageCategory("", "", "get", params);

    const list = Array.isArray(result?.data)
      ? result.data
      : (Array.isArray(result?.data?.results)
          ? result.data.results
          : (Array.isArray(result?.data?.data) ? result.data.data : []));
    setCatData(list);

    let resultVariant = await ManageVariants("", "get", "", params);

    setVariantData(resultVariant?.data);
  };

  return (
    <div>
      <div id="main-wrapper">
        <MainHeader />
        <Header name={headers} />
        <NavBar />
        {/* <Body bo={boln} na={name} nu={num} ar={ary} ob={obj} ao={aryobj} /> */}
        <Body categorys={catData} varients={variantData} />
        <Footer />
      </div>
    </div>
  );
}

export default AddProduct;
